import React from 'react';

export function LoadingSpinner() {
    return (
        <div className="flex h-[calc(100vh-96px)] flex-col items-center justify-center">
            <div className="loading-spinner" />
        </div>
    );
}
